import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveDirective as _resolveDirective, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "px-6 md:px-8 pt-6"
}
const _hoisted_2 = {
  key: 1,
  class: "px-6 md:px-8 pt-6"
}
const _hoisted_3 = {
  key: 2,
  class: "px-6 md:px-8 pt-6 space-y-6"
}
const _hoisted_4 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_5 = { class: "mt-1 text-sm text-gray-500" }
const _hoisted_6 = { class: "flex items-center justify-between gap-2 mb-4 flex-wrap" }
const _hoisted_7 = { class: "relative flex items-center" }
const _hoisted_8 = { class: "overflow-x-auto p-2 -m-2" }
const _hoisted_9 = { class: "text-gray-900 font-medium truncate" }
const _hoisted_10 = { class: "text-xs text-gray-500" }

import { MagnifyingGlassIcon } from '@heroicons/vue/20/solid'
import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue'
import { useRouter } from 'vue-router'

import ExplanationBox from '@/components/ExplanationBox.vue'
import NeueTablist from '@/components/neue/NeueTablist.vue'
import TablistGrid from '@/components/neue/TablistGrid.vue'
import TablistHeader from '@/components/neue/TablistHeader.vue'
import TablistRow from '@/components/neue/TablistRow.vue'
import ReportChart from '@/components/reports/ReportChart.vue'
import api from '@/store/api'

const CHART_COLOR = 'rgb(71, 114, 196)'

const pageSize = 25

export default {
  __name: 'LoyaltyProgramOverview',
  setup(__props) {

const customerCols = [
  { width: 'minmax(150px, 2fr)' },
  { width: 'minmax(110px, 1fr)' },
  { width: 'minmax(150px, 1fr)' },
  { width: 'minmax(120px, 1fr)' },
  { width: 'minmax(120px, 1fr)' }
]

const router = useRouter()

const programLoading = ref(true)
const program = ref(null)
const loadFailed = ref(false)
const isLive = computed(() => program.value?.attributes?.is_active === true)

const chartLoading = ref(true)
const chartData = ref({ labels: [], datasets: [] })

const customersLoading = ref(true)
const customers = ref([])
const page = ref(1)
const totalRecords = ref(0)
const totalPages = ref(0)
const searchQuery = ref('')
let searchDebounceTimer = null

const programSummary = computed(() => {
  const attrs = program.value?.attributes
  if (!attrs) return ''
  if (attrs.loyalty_program_type === 'amount') {
    return `Every ${attrs.interval_amount.format} spent earns ${attrs.reward.format} in account credit.`
  }
  const orders = attrs.order_interval
  return orders === 1
    ? `Every order earns ${attrs.reward.format} in account credit.`
    : `Every ${orders} orders earn ${attrs.reward.format} in account credit.`
})

const formatDate = dateStr => {
  if (!dateStr) return '-'
  return new Date(dateStr).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
}

const orderCountLabel = count => `${count} ${count === 1 ? 'order' : 'orders'}`

const fetchProgram = async () => {
  programLoading.value = true
  try {
    const response = await api.call('GET', 'loyalty/program')
    program.value = response.data.data
  } catch (error) {
    if (error.response?.status === 404) {
      program.value = null
    } else {
      loadFailed.value = true
      // eslint-disable-next-line no-console
      console.error('Error fetching loyalty program:', error)
    }
  } finally {
    programLoading.value = false
  }
}

const fetchChart = async () => {
  chartLoading.value = true
  try {
    const response = await api.call('GET', 'loyalty/monthly_rewards?months=12')
    const months = response.data.data || []
    chartData.value = {
      labels: months.map(month => month.attributes.period_label),
      datasets: [
        {
          label: 'Credit issued',
          data: months.map(month => Number((month.attributes.amount.cents / 100).toFixed(2))),
          backgroundColor: CHART_COLOR,
          borderColor: CHART_COLOR,
          yAxisID: 'y'
        }
      ]
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error fetching loyalty chart:', error)
    chartData.value = { labels: [], datasets: [] }
  } finally {
    chartLoading.value = false
  }
}

const fetchCustomers = async () => {
  customersLoading.value = true
  let url = `loyalty/customers?page=${page.value}&page_size=${pageSize}`
  if (searchQuery.value) url += `&search=${encodeURIComponent(searchQuery.value)}`
  try {
    const response = await api.call('GET', url)
    customers.value = response.data.data || []
    totalRecords.value = response.data.total_records || 0
    totalPages.value = response.data.total_pages || 0
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error fetching loyalty customers:', error)
    customers.value = []
    totalRecords.value = 0
    totalPages.value = 0
  } finally {
    customersLoading.value = false
  }
}

const prevPage = ret => {
  if (page.value > 1) {
    page.value--
    fetchCustomers()
    if (ret) ret()
  }
}

const nextPage = ret => {
  if (page.value < totalPages.value) {
    page.value++
    fetchCustomers()
    if (ret) ret()
  }
}

watch(searchQuery, () => {
  clearTimeout(searchDebounceTimer)
  searchDebounceTimer = setTimeout(() => {
    page.value = 1
    fetchCustomers()
  }, 300)
})

watch(isLive, live => {
  if (live) {
    fetchChart()
    fetchCustomers()
  }
})

onMounted(fetchProgram)
onBeforeUnmount(() => clearTimeout(searchDebounceTimer))

return (_ctx, _cache) => {
  const _component_SecondaryTop = _resolveComponent("SecondaryTop")
  const _component_NeueButton = _resolveComponent("NeueButton")
  const _component_EmptyState = _resolveComponent("EmptyState")
  const _component_NeueWell = _resolveComponent("NeueWell")
  const _component_NeueLoading = _resolveComponent("NeueLoading")
  const _component_NeuePagination = _resolveComponent("NeuePagination")
  const _component_SecondaryNav = _resolveComponent("SecondaryNav")
  const _directive_tippy = _resolveDirective("tippy")

  return (_openBlock(), _createBlock(_component_SecondaryNav, null, {
    top: _withCtx(() => [
      _createVNode(_component_SecondaryTop, {
        text: "Loyalty program",
        "save-status": false,
        sections: [
          {
            id: 'overview',
            name: 'Overview',
            active: true
          },
          {
            id: 'settings',
            name: 'Settings',
            action: () => _unref(router).push('/store/loyalty-program/settings')
          }
        ]
      }, null, 8, ["sections"])
    ]),
    main: _withCtx(() => [
      _createVNode(_component_NeueLoading, { loading: programLoading.value }, {
        default: _withCtx(() => [
          (loadFailed.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(ExplanationBox, { "explanation-text": "We could not load your loyalty program. Refresh the page to try again." })
              ]))
            : (!isLive.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_component_NeueWell, { class: "text-center" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_EmptyState, {
                        plural: "loyalty program",
                        description: "Reward repeat customers with account credit every few orders or every set amount spent."
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_NeueButton, {
                            type: "primary",
                            onClick: _cache[0] || (_cache[0] = $event => (_unref(router).push('/store/loyalty-program/settings')))
                          }, {
                            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                              _createTextVNode(" Set up loyalty program ", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(_component_NeueWell, null, {
                    default: _withCtx(() => [
                      _createElementVNode("p", _hoisted_4, _toDisplayString(programSummary.value), 1),
                      _createElementVNode("p", _hoisted_5, _toDisplayString(program.value.attributes.customers_rewarded_count) + " customers rewarded, " + _toDisplayString(program.value.attributes.total_rewarded.format) + " in credit issued all time. ", 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_NeueLoading, { loading: chartLoading.value }, {
                    default: _withCtx(() => [
                      _createVNode(ReportChart, {
                        "report-id": "loyalty-credit-issued",
                        title: "Loyalty credit issued",
                        description: "Last 12 months",
                        "empty-state-title": "No loyalty credit issued in the last 12 months",
                        "empty-state-description": "Rewards appear here as customers earn them.",
                        "chart-data": chartData.value,
                        "chart-type": "stackedBar",
                        "currency-format": true,
                        "date-filter": false,
                        "dropdown-filter": false,
                        "has-supporting-table": false,
                        loading: chartLoading.value
                      }, null, 8, ["chart-data", "loading"])
                    ]),
                    _: 1
                  }, 8, ["loading"]),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_6, [
                      _cache[3] || (_cache[3] = _createElementVNode("h3", { class: "text-base font-medium text-gray-900" }, "Customers", -1)),
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(_unref(MagnifyingGlassIcon), { class: "pointer-events-none absolute left-3 h-4 w-4 text-gray-500" }),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((searchQuery).value = $event)),
                          type: "text",
                          class: "h-[34px] w-56 pl-9 pr-3 rounded-full border border-gray-300 bg-white text-sm text-gray-700 placeholder-gray-500 shadow-sm focus:outline-none focus:ring-1 focus:ring-brand-500 focus:border-brand-500",
                          placeholder: "Search customers..."
                        }, null, 512), [
                          [_vModelText, searchQuery.value]
                        ])
                      ])
                    ]),
                    _createVNode(_component_NeueLoading, { loading: customersLoading.value }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_8, [
                          _createVNode(NeueTablist, null, {
                            head: _withCtx(() => [
                              _createVNode(TablistHeader, null, {
                                default: _withCtx(() => [
                                  _createVNode(TablistGrid, {
                                    columns: customerCols,
                                    header: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _cache[5] || (_cache[5] = _createElementVNode("div", null, "Customer", -1)),
                                      _cache[6] || (_cache[6] = _createElementVNode("div", null, "First ordered", -1)),
                                      _cache[7] || (_cache[7] = _createElementVNode("div", null, "Lifetime purchases", -1)),
                                      _cache[8] || (_cache[8] = _createElementVNode("div", null, "Loyalty earned", -1)),
                                      _withDirectives((_openBlock(), _createElementBlock("div", null, [...(_cache[4] || (_cache[4] = [
                                        _createTextVNode(" Credit balance ", -1)
                                      ]))])), [
                                        [_directive_tippy, { content: 'Includes all account credit, not only loyalty rewards' }]
                                      ])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customers.value, (customer) => {
                                return (_openBlock(), _createBlock(TablistRow, {
                                  key: customer.id
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(TablistGrid, { columns: customerCols }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_9, _toDisplayString(customer.attributes.customer_name), 1),
                                        _createElementVNode("div", null, _toDisplayString(formatDate(customer.attributes.first_ordered_at)), 1),
                                        _createElementVNode("div", null, [
                                          _createElementVNode("div", null, _toDisplayString(customer.attributes.lifetime_purchases.format), 1),
                                          _createElementVNode("div", _hoisted_10, _toDisplayString(orderCountLabel(customer.attributes.order_count)), 1)
                                        ]),
                                        _createElementVNode("div", null, _toDisplayString(customer.attributes.loyalty_earned.format), 1),
                                        _createElementVNode("div", null, _toDisplayString(customer.attributes.credit_balance.format), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]),
                        (!customersLoading.value && !customers.value.length)
                          ? (_openBlock(), _createBlock(_component_NeueWell, {
                              key: 0,
                              class: "text-center mt-4"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_EmptyState, {
                                  plural: "customers",
                                  description: 
                    searchQuery.value
                      ? 'No customers match your search.'
                      : 'Customers appear here after their first paid order.'
                  
                                }, null, 8, ["description"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (totalRecords.value > pageSize)
                          ? (_openBlock(), _createBlock(_component_NeuePagination, {
                              key: 1,
                              size: totalRecords.value,
                              from: (page.value - 1) * pageSize + 1,
                              to: Math.min(page.value * pageSize, totalRecords.value),
                              onPrev: prevPage,
                              onNext: nextPage
                            }, null, 8, ["size", "from", "to"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["loading"])
                  ])
                ]))
        ]),
        _: 1
      }, 8, ["loading"])
    ]),
    _: 1
  }))
}
}

}